import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
//import { SweetAlertOptions } from 'sweetalert2';
import { MyErrorStateMatcher } from '../login';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';


@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;
    @ViewChild('passmatch') private passmatchSwal: SwalComponent;
    @ViewChild('resetPassSwal') private resetPassSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    passwordFormControl = new FormControl('', [Validators.required,]);
    reenterpassFormControl = new FormControl('', [Validators.required,]);


    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    isShowPass = true;
    isReset = false;
    resetMsg: string;
    hide = true;
    hide1 = true;
    studentid: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        this.studentid = parseInt(step);


        // reset login status
        // this.authenticationService.logout();
        // this.spinner.hide();

        // get return url from route parameters or default to '/'
        //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        // this.returnUrl = '/';
    }

    ngAfterViewInit() {
        // this.detectBrowserSuport();
    }
    // detectBrowserSuport() {
    //     throw new Error('Method not implemented.');
    // }

    onSubmit() {

        this.submitted = true;
        /* stop here if form is invalid */
        if (this.passwordFormControl.value == '' || this.reenterpassFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        if ( this.passwordFormControl.value != this.reenterpassFormControl.value) {
            this.isErrorLogin = true;
            this.errorMsg = "The password and confirmation password should be same.";
            return false;
        }        
        else {  
            this.loading = true;
            this.spinner.show();
            this.authenticationService.resetPassword(this.globals.root_url, this.studentid, this.passwordFormControl.value,)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;
                            this.loading = false;
                            this.spinner.hide();
                            //this.passmatchSwal.show();
                            // var info = data.info;
                            sessionStorage.removeItem("pkshn_username_ps");
                            //this.router.navigateByUrl('/userlogin');
                            this.resetPassSwal.show();                             
                            this.goToLogin(); 
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = data.status;
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid Reset Password !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }

    login() {
        this.router.navigate(['/userlogin'])
    }
    goToLogin()
    {
        this.router.navigateByUrl('/userlogin');  
    }
}